import { AxiosError } from 'axios';
import { z } from 'zod';

import { PersonalBackgroundFormSchema } from '@/components/forms/schemas/PersonalBackgroundFormSchema';
import { ZEE_BACKGROUND_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { ZeeBackground } from '@/types/zee.type';

export type CreateZeeBackgroundApiPayload = z.infer<
  typeof PersonalBackgroundFormSchema
> & {
  industry_background: string[];
  industry_interest: Record<string, number>;
};

export const createZeeBackground = async (
  payload: CreateZeeBackgroundApiPayload
): Promise<ApiResponse<ZeeBackground>> => {
  try {
    const response = await apiManager.post(ZEE_BACKGROUND_API_URL, payload, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
